import { combineReducers } from 'redux';
import UserUidCode from './ReduxServices/Reducers'

const rootReducer  = combineReducers({
    UserUidCode,
})

export default rootReducer;
